"use client";

import Image, { type ImageProps } from "next/image";
import { useState } from "react";
import fallbackImage from "../../public/images/logo.png";

interface ImageWithFallbackProps extends ImageProps {
	fallback?: ImageProps["src"];
}

export default function ImageWithFallback({
	fallback = fallbackImage,
	alt,
	src,
	...props
}: ImageWithFallbackProps) {
	const [error, setError] = useState<React.SyntheticEvent<
		HTMLImageElement,
		Event
	> | null>(null);

	return (
		<Image
			alt={alt}
			onError={setError}
			src={error ? fallback : src}
			{...props}
		/>
	);
}
